<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card">
      <el-button
        size="medium"
        type="primary"
        plain
        icon="el-icon-plus"
        style="margin-bottom: 10px"
        @click="openDialog(true, null, 0)"
        >新增任务</el-button
      >
      <el-table :data="data" border size="small" style="margin-top: 10px">
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goalType"
          label="目标类型"
          align="center"
          width="80"
        >
          <template slot="header">
            <span>目标类型</span>
            <div>
              <el-tooltip effect="dark" placement="top">
                <div slot="content">
                  <MicrofilmComponent
                    :keyword="'heroUpgradeTask-goalType'"
                  ></MicrofilmComponent>
                </div>
                <span
                  ><i class="el-icon-question" style="font-size: 1.2em"></i
                ></span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.goalType }}
          </template>
        </el-table-column>
        <el-table-column
          prop="typeDetermination"
          label="类型判断"
          align="center"
          width="80"
        >
          <template slot="header">
            <span>类型判断</span>
            <div>
              <el-tooltip effect="dark" placement="top">
                <div slot="content">
                  <MicrofilmComponent
                    :keyword="'heroUpgradeTask-typeDetermination'"
                  ></MicrofilmComponent>
                </div>
                <span
                  ><i class="el-icon-question" style="font-size: 1.2em"></i
                ></span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.typeDetermination }}
          </template>
        </el-table-column>
        <el-table-column
          prop="schedule1"
          label="任务条件1"
          align="center"
          width="80"
        >
          <template slot="header">
            <span>任务条件1</span>
            <div>
              <el-tooltip effect="dark" placement="top">
                <div slot="content">
                  <MicrofilmComponent
                    :keyword="'heroUpgradeTask-schedule1'"
                  ></MicrofilmComponent>
                </div>
                <span
                  ><i class="el-icon-question" style="font-size: 1.2em"></i
                ></span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.schedule1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="schedule2"
          label="任务条件2"
          align="center"
          width="80"
        >
          <template slot="header">
            <span>任务条件2</span>
            <div>
              <el-tooltip effect="dark" placement="top">
                <div slot="content">
                  <MicrofilmComponent
                    :keyword="'heroUpgradeTask-schedule2'"
                  ></MicrofilmComponent>
                </div>
                <span
                  ><i class="el-icon-question" style="font-size: 1.2em"></i
                ></span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.schedule2 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="jumpType"
          label="跳转类型"
          align="center"
          width="80"
        >
          <template slot="header">
            <span>跳转类型</span>
            <div>
              <el-tooltip effect="dark" placement="top">
                <div slot="content">
                  <MicrofilmComponent
                    :keyword="'heroUpgradeTask-jumpType'"
                  ></MicrofilmComponent>
                </div>
                <span
                  ><i class="el-icon-question" style="font-size: 1.2em"></i
                ></span>
              </el-tooltip>
            </div>
          </template>
          <template slot-scope="scope">
            {{ scope.row.jumpType }}
          </template>
        </el-table-column>
        <el-table-column
          prop="desc"
          label="任务描述"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <el-popover placement="top" width="400" trigger="hover">
              <el-descriptions :column="1" border>
                <el-descriptions-item
                  :labelStyle="{ width: '55px' }"
                  v-for="(value, language, index) in scope.row.desc"
                  :key="index"
                  :label="language"
                  >{{ value }}</el-descriptions-item
                >
              </el-descriptions>
              <div slot="reference" style="white-space: nowrap">
                <div
                  v-for="(value, language, index) in scope.row.desc"
                  :key="index"
                  style="text-align: left"
                >
                  {{ language }}：{{ value }}
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="rewards" label="奖励" align="center" width="396">
          <template slot-scope="scope">
            <ShowItems :items="scope.row.rewards" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
import MicrofilmComponent from "@/components/MicrofilmComponent";

export default {
  data() {
    return {
      data: [],
      payPointMap: {},
    };
  },
  components: {
    ShowItems,
    MicrofilmComponent,
  },
  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter).tasks;
    }
  },

  props: {
    parameter: "",
  },

  watch: {},

  computed: {},

  methods: {
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditHeroUpgradeTaskDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.push(param);
            } else {
              this.$set(that.data, index, param);
            }

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除任务(ID：${this.data[index].id})？`);
        this.data.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async loadConfig() {},

    async updatedParam() {
      this.$emit("updated", JSON.stringify({ tasks: this.data }));
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>